export default [{ label: 'Monsieur', value: 1 }, { label: 'Madame', value: 2 }];
